import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyFiles = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_620_3295",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_620_3295)",
			children: /* @__PURE__ */ _jsx("path", { d: "M18 6.445V17.1C18.0011 17.2174 17.9787 17.3339 17.9343 17.4426C17.8898 17.5513 17.8242 17.6501 17.7411 17.7331C17.6581 17.8162 17.5593 17.8818 17.4506 17.9263C17.3419 17.9707 17.2254 17.9931 17.108 17.992H6.44501C6.32132 18.0038 6.19653 17.9895 6.07865 17.9503C5.96077 17.911 5.85239 17.8475 5.76047 17.7639C5.66855 17.6803 5.5951 17.5784 5.54485 17.4648C5.49459 17.3511 5.46863 17.2283 5.46863 17.104C5.46863 16.9797 5.49459 16.8569 5.54485 16.7432C5.5951 16.6296 5.66855 16.5277 5.76047 16.4441C5.85239 16.3605 5.96077 16.297 6.07865 16.2577C6.19653 16.2185 6.32132 16.2042 6.44501 16.216H16.219V6.445C16.2073 6.3213 16.2215 6.19652 16.2608 6.07863C16.3 5.96075 16.3635 5.85238 16.4471 5.76045C16.5307 5.66853 16.6326 5.59509 16.7462 5.54483C16.8599 5.49458 16.9828 5.46862 17.107 5.46862C17.2313 5.46862 17.3542 5.49458 17.4678 5.54483C17.5814 5.59509 17.6833 5.66853 17.7669 5.76045C17.8505 5.85238 17.914 5.96075 17.9533 6.07863C17.9925 6.19652 18.0068 6.3213 17.995 6.445H18ZM13.109 14.445H3.33001C2.97541 14.4426 2.63623 14.2997 2.38689 14.0475C2.13755 13.7954 1.99842 13.4546 2.00001 13.1V3.33C2.00001 2.97726 2.14014 2.63897 2.38956 2.38955C2.63899 2.14012 2.97728 2 3.33001 2H13.1C13.4536 1.99999 13.7928 2.13983 14.0437 2.389C14.2945 2.63816 14.4366 2.97644 14.439 3.33V13.1C14.4395 13.2762 14.4053 13.4507 14.3382 13.6136C14.2712 13.7766 14.1726 13.9246 14.0482 14.0494C13.9239 14.1742 13.7761 14.2732 13.6134 14.3407C13.4506 14.4082 13.2762 14.443 13.1 14.443L13.109 14.445ZM10.255 7.845L7.11901 5.957C7.05162 5.91691 6.97485 5.89529 6.89643 5.89434C6.81802 5.89338 6.74074 5.91312 6.67239 5.95155C6.60404 5.98999 6.54703 6.04576 6.50711 6.11326C6.46719 6.18076 6.44577 6.25759 6.44501 6.336V10.1C6.44436 10.1791 6.46475 10.2569 6.5041 10.3256C6.54344 10.3942 6.60033 10.4511 6.66892 10.4905C6.73751 10.5299 6.81534 10.5503 6.89444 10.5497C6.97353 10.5491 7.05104 10.5274 7.11901 10.487L10.25 8.6C10.3164 8.56152 10.3716 8.50624 10.4099 8.43972C10.4483 8.37321 10.4685 8.29778 10.4685 8.221C10.4685 8.14422 10.4483 8.0688 10.4099 8.00228C10.3716 7.93576 10.3164 7.88049 10.25 7.842L10.255 7.845Z" })
		})
	]
});
const ForwardRef = forwardRef(SvgMyFiles);
export default ForwardRef;
